/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import {
  useSMGetPageContent,
  useSMCreateBatchSerialization,
} from '../machines';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  ProgressBar,
  BodyContainer,
  LeftContainer,
  RightContainer,
  BodyTitle,
  SubmitButton,
  Preview,
  Conclusion,
  NextButton,
} from '../components';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { useTheme } from '@providers/theme';
import { NewBatchSerializationPageService } from '../services';
import { VApplication } from '@/application';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.NewBatchSerializationPageService'
  ) as NewBatchSerializationPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const [activeStep, setActiveStep] = useState(0);
  const [template, setTemplate] = useState<string>('');
  const { campaignListSend, campaignListState } = useSMGetPageContent({});
  const { createBatchSerializationSend, createBatchSerializationState } =
    useSMCreateBatchSerialization({});

  const onActiveStepChange = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const onStepperClose = () => {
    // srv?.resetFormData();
    // props?.onCloseClick && props?.onCloseClick();
  };

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onTemplateFormSubmit = (data: any) => {
    console.log('onTemplateFormSubmit data', data);
    window.scrollTo(0, 0);
    setTemplate(data?.template);
    // srv?.setSupplyCropForm(data);
    setActiveStep(activeStep + 1);
  };

  const onCreateCampaignSubmit = (data: any) => {
    // srv?.setTemplateForm(data);
    // srv?.createCampaign();
    //createBatchSerializationSend({ type: 'CREATE_CAMPAIGN', data });
  };

  const _renderBody = () => {
    const formFields =
      staticPageContentConfig?.createCampaign?.selectTemplateForm;
    const templateForm =
      staticPageContentConfig?.createCampaign?.templateForm.find(
        (item: any) => item?.type === template
      );
    switch (activeStep) {
      case 0:
        return (
          <>
            <LeftContainer>
              <BodyTitle
                {...(staticPageContentConfig?.createCampaign?.step1Title || {})}
              />
              <TweetyWidget
                key={activeStep + 1}
                labelColor={theme.colors.primary}
                fields={formFields}
                // layout={
                //   campaignListState?.event?.data?.value?.cropForm?.layout
                // }
                initialData={
                  campaignListState?.event?.data?.value?.initalTemplateData
                }
                onFormSubmit={onTemplateFormSubmit}
                renderSubmitButton={renderSubmitButton}
              />
            </LeftContainer>
            <RightContainer
              rightBlockContent={
                staticPageContentConfig?.createCampaign?.step1RightBlockContent
              }
            />
          </>
        );
      case 1:
        return (
          <>
            <LeftContainer>
              <BodyTitle
                {...(staticPageContentConfig?.createCampaign?.step2Title || {})}
              />
              <TweetyWidget
                key={activeStep + 1}
                labelColor={theme.colors.primary}
                fields={templateForm?.form}
                initialData={
                  campaignListState?.event?.data?.value?.templateData
                }
                onFormSubmit={onCreateCampaignSubmit}
                // renderSubmitButton={renderSubmitButton}
              />
            </LeftContainer>
            <RightContainer
              rightBlockContent={
                staticPageContentConfig?.createCampaign?.step2RightBlockContent
              }
            />
          </>
        );
      // case 2:
      // return (
      //   <>
      //     {_renderPreviewSubmit()}
      //     {_getPreviewData()}
      //   </>
      // );
      default:
        return <div />;
    }
  };

  return (
    <>
      <ProgressBar
        onActiveStepChange={onActiveStepChange}
        activeStep={activeStep}
        totalSteps={1}
        onCloseClick={onStepperClose}
      />
      <BodyContainer>{_renderBody()}</BodyContainer>
    </>
  );
};
